import clsx from 'clsx';
import React from 'react';

export interface DividerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  label?: React.ReactNode;
  className?: string;
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ label, className = '', ...divProps }, ref) => {
    if (!label) {
      return (
        <div
          ref={ref}
          className={clsx('h-px bg-grey3', className)}
          {...divProps}
        />
      );
    }

    return (
      <div
        ref={ref}
        className={clsx('flex items-center gap-4', className)}
        {...divProps}
      >
        <span className="h-px flex-1 bg-grey3" />
        <span className="shrink-0 text-sm font-bold uppercase tracking-wide text-light">
          {label}
        </span>
        <span className="h-px flex-1 bg-grey3" />
      </div>
    );
  }
);

Divider.displayName = 'Divider';

export default Divider;
